import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import "../../Assets/CSS/TaskDetailedPage.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const TaskDetailedPage = () => {
  const { taskId } = useParams();   // 🔹 get task id from URL
  const navigate = useNavigate();

  const [task, setTask] = useState(null);
  const [status, setStatus] = useState("");
  const [commentText, setCommentText] = useState("");

  const [comments, setComments] = useState([]);
  const [logs, setLogs] = useState([]);

  /* ---------------- GET TASK DETAILS ---------------- */
  const fetchTaskDetails = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/${taskId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTask(res.data);
      setStatus(mapStatus(res.data.status));
      // ✅ FETCH COMMENTS (GET /tasks/{taskId})
      setComments(
        (res.data.taskComments || []).map((c) => ({
          id: c.commentId,
          text: c.commentedText,
          user: c.commentedByEmployeeName,
          time: new Date(c.commentedAt).toLocaleString(),
        }))
      );


      setLogs([
        `Task "${res.data.taskDescription}" was loaded`,
        `Assigned to ${res.data.assignedToEmployeeName}`,
      ]);
    } catch (error) {
      console.error("Error fetching task details", error);
    }
  };

  useEffect(() => {
    fetchTaskDetails();
  }, [taskId]);

  /* ---------------- STATUS MAPPING ---------------- */
  const mapStatus = (status) => {
    if (status === "IN_PROGRESS") return "In-progress";
    if (status === "COMPLETED") return "Completed";
    return "Pending";
  };

  const reverseStatus = (status) => {
    if (status === "In-progress") return "IN_PROGRESS";
    if (status === "Completed") return "COMPLETED";
    return "PENDING";
  };

  /* ---------------- PATCH STATUS ---------------- */
  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    setStatus(newStatus);

    try {
      const token = localStorage.getItem("token");

      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/${taskId}/status?status=${reverseStatus(newStatus)}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLogs((prev) => [
        ...prev,
        `Status changed to "${newStatus}"`,
      ]);
    } catch (error) {
      console.error("Error updating status", error);
    }
  };

  // const handleAddComment = () => {
  //   if (!commentText.trim()) return;

  //   setComments((prev) => [
  //     ...prev,
  //     {
  //       id: Date.now(),
  //       text: commentText,
  //       user: "@You",
  //       time: "Just now",
  //     },
  //   ]);

  //   setLogs((prev) => [...prev, "New comment added"]);
  //   setCommentText("");
  // };
  const handleAddComment = async () => {
    if (!commentText.trim()) return;

    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/taskcomments/${taskId}`,
        {
          commentText: commentText, // ✅ correct key
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Assuming backend returns saved comment
      setComments((prev) => [
        ...prev,
        {
          id: res.data.id || Date.now(),
          text: res.data.comment || commentText,
          user: res.data.commentedBy || "@You",
          time: "Just now",
        },
      ]);

      setLogs((prev) => [...prev, "New comment added"]);
      setCommentText("");
    } catch (error) {
      console.error("Error adding comment", error);
    }
  };

  const handleMyTasPage = () => {
    navigate("/mytask");
  };

  if (!task) return null;

  return (
    <Layout>
      <div className="backgound-main-content p-3">
        <div className="task-wrapper">

          {/* HEADER */}
          <div className="task-header" onClick={handleMyTasPage} style={{ cursor: "pointer" }}>
            <Icon icon="mdi:arrow-left" />
            <button>back</button>
          </div>

          <div>
            <span className="task-title111">{task.taskDescription}</span>
          </div>

          <div className="task-body">

            {/* LEFT SIDE */}
            <div className="task-left">

              {/* STATUS */}
              <div className="task-row">
                <div className="label">Status</div>
                <div className="value">
                  <select
                    className="status-pill"
                    value={status}
                    onChange={handleStatusChange}
                  >
                    <option>Pending</option>
                    <option>In-progress</option>
                    <option>Completed</option>
                  </select>
                </div>
              </div>

              {/* ASSIGNEE */}
              <div className="task-row">
                <div className="label">Assignee</div>
                <div className="value">
                  <Icon icon="mdi:account-outline" />
                  {task.assignedToEmployeeName}
                </div>
              </div>

              {/* DATES */}
              <div className="date-row">
                <div className="task-row">
                  <div className="label">Start Date</div>
                  <div className="value">
                    <Icon icon="mdi:calendar-outline" />
                    {task.startDate}
                  </div>
                </div>

                <div className="task-row">
                  <div className="label">Due Date</div>
                  <div className="value">
                    <Icon icon="mdi:calendar-outline" />
                    {task.endDate}
                  </div>
                </div>
              </div>

              {/* PROJECT */}
              <div className="task-row">
                <div className="label">Projects</div>
                <div className="value">
                  <span className="project-pill">{task.projectName}</span>
                </div>
              </div>

              {/* COMMENTS */}
              <div className="taskdescription-comment">
                <div className="taskdescription-title-coment">Comments</div>

                <div className="comment-list">
                  {comments.map((c) => (
                    <div key={c.id} className="comment-block">
                      <p className="comment">
                        {c.text} <span>{c.user}</span>
                      </p>
                      <small>{c.time}</small>
                    </div>
                  ))}
                </div>

                <div className="comment-input-wrapper">
                  <input
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder="Enter comment..."
                  />
                  <Icon
                    icon="mingcute:send-line"
                    className="send-icon"
                    onClick={handleAddComment}
                  />
                </div>
              </div>
            </div>

            {/* RIGHT SIDE – ACTIVITY LOGS */}
            <div className="task-right">
              <div className="activity">
                <div className="activity-scroll">
                  {logs.map((log, index) => (
                    <div key={index}>
                      <p>{log}</p>
                      <small>Just now</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TaskDetailedPage;
